import { store } from '../../Store'

export const getToken = () => {
  // Se lee primero del store de Redux en memoria (siempre al día apenas se
  // despacha el login) en vez de sólo localStorage: redux-persist escribe a
  // localStorage de forma asíncrona, así que justo después de loguearse (y
  // navegar de inmediato a la siguiente pantalla) localStorage podía no
  // tener el token todavía, causando 401 en el primer request posterior al
  // login. Si por algún motivo el store no tiene el token, se cae al método
  // viejo (localStorage) como respaldo.
  const tokenFromStore = store.getState()?.auth?.user?.token
  if (tokenFromStore) return tokenFromStore

  try {
    const storage = JSON.parse(localStorage.getItem('persist:root'))
    const auth = JSON.parse(storage.auth)
    return auth?.user?.token || null
  } catch (error) {
    return null
  }
}

// HO-HU-37: cuenta "property" con mas de una propiedad vinculada -> le
// dice al backend cual es "mi propiedad" para este request (ver
// AuthCredential::activeProperty() en el backend). Para toda cuenta con
// una sola propiedad (el caso de hoy) selectedProperty nunca se llega a
// setear, asi que este header simplemente no se manda -- cero cambio de
// comportamiento.
const getSelectedPropertyId = () => {
  try {
    return store.getState()?.property?.selectedProperty || null
  } catch (error) {
    return null
  }
}

export const selectedPropertyHeader = () => {
  const selectedPropertyId = getSelectedPropertyId()
  return selectedPropertyId ? { 'X-Property-Id': String(selectedPropertyId) } : {}
}

export const authorizationHeaders = (additionalHeaders = {}) => ({
  'Content-Type': 'application/json',
  Accept: 'application/json, text/plain, */*',
  Authorization: `Bearer ${getToken()}`,
  ...selectedPropertyHeader(),
  ...additionalHeaders
})
